import {z} from 'zod'

export const Media = z.object({
    id: z.number().int().positive(),
    name: z.string()
})
export type Media = z.infer<typeof Media>
